<template>
    <div class="c-limited-subscription-summary">
        <b-card no-body>
            <div slot="header">
                {{caption}}
                <div class="card-header-actions pull-right">
                    <b-button @click="open" type="button" variant="info">{{Core.Definition.getDefinition('Sélection produit')}}
                    </b-button>
                </div>
            </div>
            <b-card-body>
                <ProductSummary
                        ref="productSummary"
                        :fieldRefs="fieldRefs"
                        @updateTotal="updateTotal"
                        :evalFromQuantity="false"
                        v-model="dataProducts"></ProductSummary>
                <div v-if="required && !chkState(id)" style="display: block" class="invalid-feedback">
                    <span v-if="invalidFeedbackMessage !== ''">{{invalidFeedbackMessage}}</span>
                    <span v-if="invalidFeedbackMessage === ''">{{Core.Definition.getDefinition('Vous devez sélectionner un produit.')}}</span>
                </div>
                <ModalInstanceSelector
                        :caption="Core.Definition.getDefinition('Liste des produits')"
                        ref="modalInstanceSelector"
                        root="/product/list"
                        quantityStep="bookingLimit"
                        v-model="dataProducts"
                        :multiple="false"
                        :searchFormStructure="{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'id'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'title'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'id',
                                    type: 'number',
                                    label: Core.Definition.getDefinition('ID'),
                                    value: ''
                                },
                                {
                                    id: 'title',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Titre'),
                                    value: ''
                                }
                            ]
                        }"
                        :searchArgs="[
                            {
                                key: 'type',
                                value: Core.Product.typeLimitedSubscription
                            }
                        ]"
                        :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun produit limité à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                        :columns="[
                                {
                                    label: Core.Definition.getDefinition('#'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Prix régulier'),
                                    key: 'Readable.regularPrice',
                                    type: 'text',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import InputDatePicker from './InputDatePicker'
    import ProductSummary from './ProductSummary'
    import ModalInstanceSelector from './ModalInstanceSelector'

    export default {
        name: 'ProductLimitedSubscriptionSummary',
        components: {
            ProductSummary,
            ModalInstanceSelector,
            InputDatePicker
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            caption: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            updateTotal: {
                type: Function,
                default: function () {
                    return 0
                }
            },
            onChange: {
                type: Function,
                default: function () {
                    return 0
                }
            },
            invalidFeedbackMessage: {
                type: String,
                default: ''
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataProducts = val
                },
                deep: true
            },
            dataProducts: {
                handler(val) {
                    this.onChange(val, this.form, this.fieldRefs)
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        mounted() {
            this.dataProducts = window.Core.Array.newArray(this.value)
        },
        data: () => {
            return {
                Core: window.Core,
                dataProducts: []
            }
        },
        methods: {
            open() {
                this.$refs.modalInstanceSelector.open = true
            },
            chkState(val) {
                if (this.form !== undefined && this.form[val] !== undefined) {
                    const field = this.form[val]
                    return !field.$dirty || !field.$invalid
                }
            }
        }
    }
</script>
